import React, { useState, useEffect } from 'react'
import Api from '../../../../_helpers/Api'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../_providers/Translation'
import { BarChart } from '@mui/x-charts/BarChart'

const STATUSES = [
    {
        name: trans('random.income'),
        color: "#4A3AFF",
    },
    {
        name: trans('random.expense'),
        color: "#C893FD",
    },
]
function Finances() {

    const [state, setState] = useState({
        loading: true,
        labels: [],
        incomes: [],
        expenses: [],
        diff: [],
    })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        setState(prev => ({
            ...prev,
            loading: true
        }))

        Api.get('accounts/profit')
            .then(res => {
                const dates = res.data.dates || []

                setState(prev => ({
                    ...prev,
                    labels: dates.map(d => d.label),
                    incomes: dates.map(d => d.incomes),
                    expenses: dates.map(d => d.expenses),
                    currency: res.data.currency,
                }))
            }).finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    return (
        <div className="incomes-expenses-chart">
            <div className='head'>
                <h3>
                    {trans('random.financeDifference')}
                </h3>
                <ul>
                    {STATUSES.map((status) => (
                        <li key={status.name}>
                            <span style={{ background: status.color }}></span>
                            {status.name}
                        </li>
                    ))}
                </ul>
            </div>
            <hr />

            {state.loading || !state.labels.length
                ?
                <Skeleton height={240} count={1} />
                :
                <BarChart
                    xAxis={[{
                        scaleType: 'band',
                        data: state.labels,
                    }]}
                    // yAxis={[{
                    //     valueFormatter: (value) => `${value.toFixed(2)} ${state.currency || ''}`,
                    // }]}
                    series={[
                        {
                            data: state.incomes,
                            label: STATUSES[0].name,
                            color: STATUSES[0].color,
                            valueFormatter: (value) => `${value.toFixed(2)} ${state.currency || ''}`,
                        },
                        {
                            data: state.expenses,
                            label: STATUSES[1].name,
                            color: STATUSES[1].color,
                            valueFormatter: (value) => `${value.toFixed(2)} ${state.currency || ''}`,
                        },
                    ]}
                    height={200}
                    margin={{
                        right: 0
                    }}
                    slotProps={{
                        legend: { hidden: true },
                    }}
                    borderRadius={4}
                />
            }
        </div>

    )
}

export default Finances